import { useConfirmNavigation } from "./useConfirmNavigation"

/**
 * This hook blocks navigation when changes are not saved.
 * It's used for screens that don't use Form components (e.g., managed by the `isEdit` flag).
 * @param initialDirty
 */
export function useNavigationBlocker(initialDirty = false) {
  return useConfirmNavigation(initialDirty)
}
